import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'
import useDeleteTurfQuality from '../../hooks/turfQuality/useDeleteTurfQuality'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
}

const DeleteTurfQualityModal = ({ id, interfaceId }: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeleteTurfQuality } = useDeleteTurfQuality()

  const handleDeleteTurfQuality = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal({ interfaceId, id })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={'Delete Turf Quality?'}
      text={'This action is not reversible, this Turf Quality data will be deleted.'}
      onClose={closeModal}
      onConfirm={handleDeleteTurfQuality}
      isLoading={loadingDeleteTurfQuality}
    />
  )
}

export default DeleteTurfQualityModal
